export default __webpack_public_path__ + "static/media/2-100.e9917f32.jpg";